// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shepherd-button {
  background: #0ab39c;
  border: 0;
  border-radius: 3px;
  color: rgba(255, 255, 255, 0.75);
  cursor: pointer;
  margin-right: .5rem;
  padding: .5rem 1.5rem;
  transition: all .5s ease; }

.shepherd-button:not(:disabled):hover {
  background: #196fcc;
  color: rgba(255, 255, 255, 0.75); }

.shepherd-button.shepherd-button-secondary {
  background: #f1f2f3;
  color: rgba(0, 0, 0, 0.75); }

.shepherd-button.shepherd-button-secondary:not(:disabled):hover {
  background: #d6d9db;
  color: rgba(0, 0, 0, 0.75); }

.shepherd-button:disabled {
  cursor: not-allowed; }

.shepherd-footer {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  justify-content: flex-end;
  padding: 0 .75rem .75rem; }

.shepherd-footer .shepherd-button:last-child {
  margin-right: 0; }

.shepherd-cancel-icon {
  background: transparent;
  border: none;
  color: rgba(128, 128, 128, 0.75);
  font-size: 2em;
  cursor: pointer;
  font-weight: 400;
  margin: 0;
  padding: 0;
  transition: color .5s ease; }

.shepherd-cancel-icon:hover {
  color: rgba(0, 0, 0, 0.75); }

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(128, 128, 128, 0.75); }

.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(0, 0, 0, 0.75); }

.shepherd-title {
  color: rgba(0, 0, 0, 0.75);
  display: flex;
  font-size: 1rem;
  font-weight: 400;
  flex: 1 0 auto;
  margin: 0;
  padding: 0; }

.shepherd-header {
  align-items: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  justify-content: flex-end;
  line-height: 2em;
  padding: .75rem .75rem 0; }

.shepherd-has-title .shepherd-content .shepherd-header {
  background: #e6e6e6;
  padding: 1em; }

.shepherd-text {
  color: rgba(0, 0, 0, 0.75);
  font-size: 1rem;
  line-height: 1.3em;
  padding: .75em; }

.shepherd-text p {
  margin-top: 0; }

.shepherd-text p:last-child {
  margin-bottom: 0; }

.shepherd-content {
  border-radius: 5px;
  outline: none;
  padding: 0; }

.shepherd-element {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  opacity: 0;
  outline: none;
  transition: opacity .3s,visibility .3s;
  visibility: hidden;
  width: 100%;
  z-index: 9999; }

.shepherd-enabled.shepherd-element {
  opacity: 1;
  visibility: visible; }

.shepherd-element[data-popper-reference-hidden]:not(.shepherd-centered) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden; }

.shepherd-element, .shepherd-element *, .shepherd-element :after, .shepherd-element :before {
  box-sizing: border-box; }

.shepherd-arrow, .shepherd-arrow:before {
  position: absolute;
  width: 16px;
  height: 16px;
  z-index: -1; }

.shepherd-arrow:before {
  content: "";
  transform: rotate(45deg);
  background: #fff; }

.shepherd-element[data-popper-placement^=top] > .shepherd-arrow {
  bottom: -8px; }

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -8px; }

.shepherd-element[data-popper-placement^=left] > .shepherd-arrow {
  right: -8px; }

.shepherd-element[data-popper-placement^=right] > .shepherd-arrow {
  left: -8px; }

.shepherd-element.shepherd-centered > .shepherd-arrow {
  opacity: 0; }

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: #e6e6e6; }

.shepherd-target-click-disabled.shepherd-enabled.shepherd-target, .shepherd-target-click-disabled.shepherd-enabled.shepherd-target * {
  pointer-events: none; }

.shepherd-modal-overlay-container {
  height: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: all .3s ease-out,height 0ms .3s,opacity .3s 0ms;
  width: 100vw;
  z-index: 9997; }

.shepherd-modal-overlay-container.shepherd-modal-is-visible {
  height: 100vh;
  opacity: .5;
  transition: all .3s ease-out,height 0s 0s,opacity .3s 0s; }

.shepherd-modal-overlay-container.shepherd-modal-is-visible path {
  pointer-events: all; }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/shepherd.css"],"names":[],"mappings":"AAAA;EAAiB,mBAAkB;EAAC,SAAQ;EAAC,kBAAiB;EAAC,gCAAyB;EAAC,eAAc;EAAC,mBAAkB;EAAC,qBAAoB;EAAC,wBAAuB,EAAA;;AAAC;EAAsC,mBAAkB;EAAC,gCAAyB,EAAA;;AAAC;EAA2C,mBAAkB;EAAC,0BAAqB,EAAA;;AAAC;EAAgE,mBAAkB;EAAC,0BAAqB,EAAA;;AAAC;EAA0B,mBAAkB,EAAA;;AACpe;EAAiB,8BAA6B;EAAC,+BAA8B;EAAC,aAAY;EAAC,yBAAwB;EAAC,wBAAuB,EAAA;;AAAC;EAA6C,eAAc,EAAA;;AACvM;EAAsB,uBAAsB;EAAC,YAAW;EAAC,gCAA0B;EAAC,cAAa;EAAC,eAAc;EAAC,gBAAe;EAAC,SAAQ;EAAC,UAAS;EAAC,0BAAyB,EAAA;;AAAC;EAA4B,0BAAqB,EAAA;;AAAC;EAA4D,gCAA0B,EAAA;;AAAC;EAAkE,0BAAqB,EAAA;;AAC9Y;EAAgB,0BAAqB;EAAC,aAAY;EAAC,eAAc;EAAC,gBAAe;EAAC,cAAa;EAAC,SAAQ;EAAC,UAAS,EAAA;;AAClH;EAAiB,mBAAkB;EAAC,2BAA0B;EAAC,4BAA2B;EAAC,aAAY;EAAC,yBAAwB;EAAC,gBAAe;EAAC,wBAAuB,EAAA;;AAAC;EAAuD,mBAAkB;EAAC,YAAW,EAAA;;AAC9P;EAAe,0BAAqB;EAAC,eAAc;EAAC,kBAAiB;EAAC,cAAa,EAAA;;AAAC;EAAiB,aAAY,EAAA;;AAAC;EAA4B,gBAAe,EAAA;;AAC7J;EAAkB,kBAAiB;EAAC,aAAY;EAAC,UAAS,EAAA;;AAC1D;EAAkB,gBAAe;EAAC,kBAAiB;EAAC,wCAAmC;EAAC,gBAAe;EAAC,UAAS;EAAC,aAAY;EAAC,sCAAqC;EAAC,kBAAiB;EAAC,WAAU;EAAC,aAAY,EAAA;;AAAC;EAAmC,UAAS;EAAC,mBAAkB,EAAA;;AAAC;EAAwE,UAAS;EAAC,oBAAmB;EAAC,kBAAiB,EAAA;;AAAC;EAAyF,sBAAqB,EAAA;;AAAC;EAAuC,kBAAiB;EAAC,WAAU;EAAC,YAAW;EAAC,WAAU,EAAA;;AAAC;EAAuB,WAAU;EAAC,wBAAuB;EAAC,gBAAe,EAAA;;AAAC;EAA8D,YAAW,EAAA;;AAAC;EAAiE,SAAQ,EAAA;;AAAC;EAA+D,WAAU,EAAA;;AAAC;EAAgE,UAAS,EAAA;;AAAC;EAAoD,UAAS,EAAA;;AAAC;EAA2F,yBAAwB,EAAA;;AAAC;EAAoI,oBAAmB,EAAA;;AAC5wC;EAAkC,SAAQ;EAAC,OAAM;EAAC,UAAS;EAAC,gBAAe;EAAC,oBAAmB;EAAC,eAAc;EAAC,MAAK;EAAC,2DAA0D;EAAC,YAAW;EAAC,aAAY,EAAA;;AAAC;EAA4D,aAAY;EAAC,WAAU;EAAC,wDAAuD,EAAA;;AAAC;EAAiE,mBAAkB,EAAA","sourcesContent":[".shepherd-button{background:#0ab39c;border:0;border-radius:3px;color:hsla(0,0%,100%,.75);cursor:pointer;margin-right:.5rem;padding:.5rem 1.5rem;transition:all .5s ease}.shepherd-button:not(:disabled):hover{background:#196fcc;color:hsla(0,0%,100%,.75)}.shepherd-button.shepherd-button-secondary{background:#f1f2f3;color:rgba(0,0,0,.75)}.shepherd-button.shepherd-button-secondary:not(:disabled):hover{background:#d6d9db;color:rgba(0,0,0,.75)}.shepherd-button:disabled{cursor:not-allowed}\n.shepherd-footer{border-bottom-left-radius:5px;border-bottom-right-radius:5px;display:flex;justify-content:flex-end;padding:0 .75rem .75rem}.shepherd-footer .shepherd-button:last-child{margin-right:0}\n.shepherd-cancel-icon{background:transparent;border:none;color:hsla(0,0%,50.2%,.75);font-size:2em;cursor:pointer;font-weight:400;margin:0;padding:0;transition:color .5s ease}.shepherd-cancel-icon:hover{color:rgba(0,0,0,.75)}.shepherd-has-title .shepherd-content .shepherd-cancel-icon{color:hsla(0,0%,50.2%,.75)}.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover{color:rgba(0,0,0,.75)}\n.shepherd-title{color:rgba(0,0,0,.75);display:flex;font-size:1rem;font-weight:400;flex:1 0 auto;margin:0;padding:0}\n.shepherd-header{align-items:center;border-top-left-radius:5px;border-top-right-radius:5px;display:flex;justify-content:flex-end;line-height:2em;padding:.75rem .75rem 0}.shepherd-has-title .shepherd-content .shepherd-header{background:#e6e6e6;padding:1em}\n.shepherd-text{color:rgba(0,0,0,.75);font-size:1rem;line-height:1.3em;padding:.75em}.shepherd-text p{margin-top:0}.shepherd-text p:last-child{margin-bottom:0}\n.shepherd-content{border-radius:5px;outline:none;padding:0}\n.shepherd-element{background:#fff;border-radius:5px;box-shadow:0 1px 4px rgba(0,0,0,.2);max-width:400px;opacity:0;outline:none;transition:opacity .3s,visibility .3s;visibility:hidden;width:100%;z-index:9999}.shepherd-enabled.shepherd-element{opacity:1;visibility:visible}.shepherd-element[data-popper-reference-hidden]:not(.shepherd-centered){opacity:0;pointer-events:none;visibility:hidden}.shepherd-element,.shepherd-element *,.shepherd-element :after,.shepherd-element :before{box-sizing:border-box}.shepherd-arrow,.shepherd-arrow:before{position:absolute;width:16px;height:16px;z-index:-1}.shepherd-arrow:before{content:\"\";transform:rotate(45deg);background:#fff}.shepherd-element[data-popper-placement^=top]>.shepherd-arrow{bottom:-8px}.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{top:-8px}.shepherd-element[data-popper-placement^=left]>.shepherd-arrow{right:-8px}.shepherd-element[data-popper-placement^=right]>.shepherd-arrow{left:-8px}.shepherd-element.shepherd-centered>.shepherd-arrow{opacity:0}.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{background-color:#e6e6e6}.shepherd-target-click-disabled.shepherd-enabled.shepherd-target,.shepherd-target-click-disabled.shepherd-enabled.shepherd-target *{pointer-events:none}\n.shepherd-modal-overlay-container{height:0;left:0;opacity:0;overflow:hidden;pointer-events:none;position:fixed;top:0;transition:all .3s ease-out,height 0ms .3s,opacity .3s 0ms;width:100vw;z-index:9997}.shepherd-modal-overlay-container.shepherd-modal-is-visible{height:100vh;opacity:.5;transition:all .3s ease-out,height 0s 0s,opacity .3s 0s}.shepherd-modal-overlay-container.shepherd-modal-is-visible path{pointer-events:all}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
